<script setup>
import { computed } from 'vue';

const props = defineProps({
    paginaAtual: {
        type: Number,
        required: true
    },
    linhasPorPagina: {
        type: Number,
        required: true
    },
    totalItens: {
        type: Number,
        required: true
    },
    itensExibidos: {
        type: Number,
        default: null
    },
    tipo: {
        type: String,
        required: true,
        validator: (value) => ['start', 'end'].includes(value)
    }
});

const emit = defineEmits(['update:linhasPorPagina']);

const quantidadeExibida = computed(() => {
    // Se foi passado explicitamente, usa o valor
    if (props.itensExibidos !== null) {
        return props.itensExibidos;
    }

    // Caso contrário, calcula baseado na página atual
    if (props.totalItens === 0) {
        return 0;
    }

    if (props.totalItens <= props.linhasPorPagina) {
        return props.totalItens;
    }

    // Última página pode ter menos itens
    const inicio = (props.paginaAtual - 1) * props.linhasPorPagina;
    const itensRestantes = props.totalItens - inicio;

    return Math.min(props.linhasPorPagina, itensRestantes);
});

const linhasModel = computed({
    get: () => props.linhasPorPagina,
    set: (value) => emit('update:linhasPorPagina', value)
});
</script>

<template>
    <span v-if="tipo === 'start'" class="text-xs hidden lg:block">
        Exibindo {{ quantidadeExibida }} itens de {{ totalItens }}
    </span>

    <div v-else-if="tipo === 'end'" class="hidden xl:flex align-items-center gap-2">
        <span class="text-xs white-space-nowrap">Linhas por página:</span>
        <Dropdown v-model="linhasModel" :options="[20, 50, 100]" :pt="{
            root: { style: 'height: 42px;' },
            trigger: {
                style: 'width: 12px;margin-left: 10px;margin-right: 10px;'
            }
        }" />
    </div>
</template>
